import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "@coso/loading";
import { Observable } from "rxjs";
import { IConfigurationHolder, IEntityInfo } from "../../../models/auto-generated";
import { EntitiesService } from "../../../services/entities.service";
import { SettingsStore } from "../../../stores/settings.store";
import { handleError } from "../../../utils/handle-error";

@Component({
  standalone:false,
  templateUrl: "./entity-filter.component.html",
  styleUrls: ["./entity-filter.component.scss"]
})
export class EntityFilterComponent implements OnInit {
  settings$: Observable<IConfigurationHolder>;
  readonly$: Observable<boolean>;
  entities: IEntityInfo[];
  errorMessage: string;
  instanceId: string;
  allSelected: boolean;
  constructor(public loadingService: LoadingService, private settingsStore: SettingsStore, private entitiesService: EntitiesService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.instanceId = this.route.parent.snapshot.paramMap.get("instance-id");
    this.settings$ = this.settingsStore.settings$;
    this.readonly$ = this.settingsStore.isReadOnly$;
    this.loadEntityFilterSettings();
  }

  selectAll(current: IConfigurationHolder) {
    this.allSelected = !this.allSelected;
    this.entities.forEach((entity) => {
      const index = current.entityConfiguration.enabledEntities.findIndex((e) => e.entityName === entity.logicalName);
      if (this.allSelected && index <= -1) {
        current.entityConfiguration.enabledEntities.push({ entityName: entity.logicalName, isActivity: entity.isActivity });
      }
      if (!this.allSelected && index > -1) {
        current.entityConfiguration.enabledEntities.splice(index, 1);
      }
    });
    this.settingsStore.updateSettings(current);
  }

  inputChecked(current: IConfigurationHolder, entity: IEntityInfo) {
    return current.entityConfiguration.enabledEntities.findIndex((e) => e.entityName === entity.logicalName) > -1;
  }

  inputChanged(current: IConfigurationHolder, entity: IEntityInfo) {
    const index = current.entityConfiguration.enabledEntities.findIndex((e) => e.entityName === entity.logicalName);
    if (index > -1) {
      current.entityConfiguration.enabledEntities.splice(index, 1);
    } else {
      current.entityConfiguration.enabledEntities.push({ entityName: entity.logicalName, isActivity: entity.isActivity });
    }
    this.allSelected = this.entities.length === current.entityConfiguration.enabledEntities.length;
    this.settingsStore.updateSettings(current);
  }

  updateSettings(current: IConfigurationHolder) {
    this.settingsStore.updateSettings(current);
  }

  private loadEntityFilterSettings() {
    this.loadingService.start("Loading entity filter settings", "loadEntityFilter");
    this.entitiesService.get(this.instanceId).subscribe(
      (entities) => {
        this.entities = entities;
        this.loadingService.stop("loadEntityFilter");
      },
      (error) => {
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop("loadEntityFilter");
      }
    );
  }
}
